<template>

    <div class="swipe-container bg-grey-3 w-full overflow-scroll">

        <div class="swipe-viewport flex justify-center min-w-full" :style="`width: ${viewportWidth}px;`">

            <div class="swipe-item" v-for="image in images" :key="image.id">

                <img ref="images" :style="`max-height: ${maxHeight}px;`" class="block w-auto" :src="image.url" :alt="image.caption || image.title">

            </div>

        </div>

    </div>

</template>

<script>

import { debounce } from 'underscore';

export default {

    name: 'SwipeGallery',

    props: ['images'],

    data() {
        return {
            viewportWidth: 2000,
        }
    },

    created() {
        const debouncedCalculate = debounce(() => {
            return this.calculateViewportWidth();
        }, 300);

        window.addEventListener('load', debouncedCalculate);
        window.addEventListener('resize', debouncedCalculate);
        document.addEventListener('ready', debouncedCalculate);
    },

    mounted() {
        this.viewportWidth = this.defaultWidth;
        this.calculateViewportWidth();
    },

    methods: {
        calculateViewportWidth() {
            console.log('go');
            let width = 0;

            this.$refs.images.forEach(i => {
                width = width + i.clientWidth;
            });

            this.viewportWidth = width;
        },
    },

    computed: {

        defaultWidth() {
            let width = 0;

            this.images.forEach(i => {
                width = width + i.width;
            });

            return width;
        },

        maxHeight() {
            let height = 99999;

            this.images.forEach(i => {
                if (i.height < height) {
                    height = i.height;
                }
            });

            return height;
        },

    },

}

</script>

<style lang="scss">
    .swipe-viewport {
        -webkit-overflow-scrolling: touch;
    }
</style>



// WEBPACK FOOTER //
// web/app/themes/giles/resources/js/components/SwipeGallery.vue